import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMediaQuery, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AnnouncementIcon from '@material-ui/icons/Announcement';

// STYLES
import { LessChannelsAlertStyled } from './styles';

const LessChannelsAlert = ({ onClose, onClick }) => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const [t] = useTranslation();

  const actionButton = isMobile ? (
    <IconButton color="inherit" size="small" onClick={onClose}>
      <CloseIcon />
    </IconButton>
  ) : (
    <Button variant="text" color="inherit" size="small" onClick={onClose}>
      {t('buttons.dismiss')}
    </Button>
  );

  return (
    <LessChannelsAlertStyled
      variant="filled"
      severity="info"
      iconMapping={{ info: <AnnouncementIcon /> }}
      action={actionButton}
    >
      <p className="p2">{t('channels.lessChannels.title')}</p>
      <Button
        color="secondary"
        fullWidth
        className="learn-more__button"
        size="small"
        onClick={onClick}
      >
        {t('buttons.learnMore')}
      </Button>
    </LessChannelsAlertStyled>
  );
};

LessChannelsAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(LessChannelsAlert);
